import { get } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  actions: {
    retrieveRegions: () => get('/regions'),

    retrieveRegionByZip: (_, zip) => get(`/regions/filters/byZipCode?search=${zip}`),
  }
};
